import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { connect } from 'react-redux';
//Styling
import styled from "styled-components";

function ProductsGroups(props) {
  const { categories } = props;

  return (
    <div className="container">
      <ProductsGroup>
        <div className="row justify-content-center">
          <div className="col-xl-4 col-lg-6 mb-2">
            <div className="category-card" style={{backgroundImage: "url(assets/images/product-group/buduj-sciany.webp)"}}>
              <h2>Buduj ściany</h2>
              <ul>
                <li><Link to="szukaj/beton%20komórkowy">Beton komórkowy</Link></li>
                <li><Link to="szukaj/pustak%20silikat">Pustak silikat</Link></li>
                <li><Link to="szukaj/pustak%20ceramiczny">Pustak ceramiczny</Link></li>
                <li><Link to="szukaj/zaprawa%20murarska">Zaprawa murarska</Link></li>
                <li><Link to="szukaj/nadproża">Nadproża</Link></li>
              </ul>
              <Link to="https://buduj.pl/szukaj/gbs" className="all-categories">Wszystko do ścian</Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-2">
            <div className="category-card" style={{backgroundImage: "url(assets/images/product-group/kupuj-narzedzia.webp)"}}>
              <h2>Kupuj narzędzia</h2>
              <ul>
                <li><Link to="szukaj/betoniarki">Betoniarki</Link></li>
                <li><Link to="szukaj/kielnie%20i%20szpachle">Kielnie i szpachle</Link></li>
                <li><Link to="szukaj/taczki%20i%20wózki">Taczki i wózki</Link></li>
                <li><Link to="szukaj/rusztowanie%20warszawskie">Rusztowanie warszawski</Link></li>
              </ul>
              <Link to="https://buduj.pl/szukaj/gnb" className="all-categories">Wszystkie narzędzia</Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-2">
            <div className="category-card" style={{backgroundImage: "url(assets/images/product-group/ocieplaj-poddasze.webp)"}}>
              <h2>Ocieplaj poddasze</h2>
              <ul>
                <li><Link to="szukaj/wełny">Wełny</Link></li>
                <li><Link to="szukaj/folia%20paroizolacyjna">Folia paroizolacyjna</Link></li>
                <li><Link to="szukaj/płyty">Płyty</Link></li>
                <li><Link to="szukaj/profile%20sufitowe">Profile sufitowe</Link></li>
                <li><Link to="szukaj/masy%20szpachlowe">Masy szpachlowe</Link></li>
              </ul>
              <Link to="https://buduj.pl/szukaj/gop" className="all-categories">Wszystko do ocieplania poddasza</Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-2">
            <div className="category-card" style={{backgroundImage: "url(assets/images/product-group/stawiaj-fundamenty.webp)"}}>
              <h2>Stawiaj fundamenty</h2>
              <ul>
                <li><Link to="szukaj/cementy">Cementy</Link></li>
                <li><Link to="szukaj/zbrojenie%20betonu">Zbrojenie betonu</Link></li>
                <li><Link to="szukaj/folia%20kubełkowa">Folia kubełkowa</Link></li>
                <li><Link to="szukaj/izolacja%20fundamentów">Izolacja fundamentów</Link></li>
                <li><Link to="szukaj/bloczki%20betonowe">Bloczki betonowe</Link></li>
              </ul>
              <Link to="https://buduj.pl/szukaj/gdf" className="all-categories">Wszystko do fundamentów</Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-2">
            <div className="category-card" style={{backgroundImage: "url(assets/images/product-group/ocieplaj-elewacje.webp)"}}>
              <h2>Ocieplaj elewacje</h2>
              <ul>
                <li><Link to="szukaj/styropian">Styropian</Link></li>
                <li><Link to="szukaj/wełna%20elewacyjna">Wełna elewacyjna</Link></li>
                <li><Link to="szukaj/tynki%20silikonowe">Tynki silikonowe</Link></li>
                <li><Link to="szukaj/siatka%20podtynkowa">Siatka podtynkowa</Link></li>
                <li><Link to="szukaj/narożnik%20aluminiowy">Narożnik aluminiowy</Link></li>
              </ul>
              <Link to="https://buduj.pl/szukaj/goe" className="all-categories">Wszystko do ocieplania elewacji</Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-2">
            <Link to="info/mapa-zasiegu">
              <div className="category-card" style={{backgroundImage: "url(assets/images/product-group/mapa-dostaw.webp)", backgroundSize: "contain", height: "230px", backgroundPosition: "center"}}></div>
            </Link>
          </div>
        </div>
      </ProductsGroup>
    </div>
  );
}

const ProductsGroup = styled.div`
  font-family: "Ubuntu", sans-serif;
  h2 {
    font-size: 2.3rem;
    font-weight: 500;
    letter-spacing: -1px;
  }
  a {
    font-family: "Open Sans", sans-serif;
    font-size: 15px;
  }
  ul {
    list-style: none;
    margin-bottom: 1.5rem;

    li {
      line-height: 1.5
    }
  }
  .all-categories {
    font-family: "Bebas Neue", sans-serif;
    color: #ff6a00;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 1px;

    &:hover {
      color: #002b4f;
    }
  }
  .category-card {
    background-color: #fff;
    background-repeat: no-repeat;
    border-radius: 30px;
    background-position: right center;
    height: 230px;
    padding: 2rem;
    background-size: 55%;
  }
  @media (max-width: 991px) {
    h2 {
      font-size: 2rem;
    }
    ul {
      li {
        a {
          font-size: 13px;
        }
      }
    }
    .category-card {
      height: auto;
      background-size: 40%;
    }
  }
  @media (max-width: 576px) {
    .category-card {
      background-size: 50%;
    }
  }
`;

const mapStateToProps = ( state ) => {
  return {
    categories: state.categories.categories ? state.categories.categories : []
  }
}

export default connect(mapStateToProps)(ProductsGroups);